module.exports = __webpack_public_path__ + "img/lasso-sparkles.faf45348.svg";